export enum HabilitationStatusEnum {
  EXPIRED = "expired",
  EXPIRING_SOON = "expiring_soon",
  UNKNOWN = "unknown",
  VALID = "valid",
  COMING = "coming",
  MISSING_HABILITATION = "missing_habilitation",
}
